import React from "react";

export interface TButton {
    onClick?: () => void;
    title: string;
    className?: string;
    loading?: boolean;
    disabled?: boolean;
    secondary?: boolean;
    type?: "button" | "submit" | "reset" | undefined
}

const Button: React.FC<TButton> = ({ onClick, title, className, loading, disabled, secondary, type }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled || loading}
            type={type ?? 'button'}
            className={`
                px-6 py-2.5 rounded-xl font-semibold transition-all duration-200 active:scale-95
                ${disabled || loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
                ${secondary 
                    ? 'bg-gray-100 text-gray-700 hover:bg-gray-200' 
                    : 'bg-primary text-white hover:bg-primary/90 shadow-sm shadow-primary/20 hover:shadow-md'}
                ${className}
            `}
        >
            {loading ? (
                <div className="flex items-center justify-center gap-2 text-white">
                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    <span>{title}</span>
                </div>
            ) : title}
        </button>
    );
};

export default Button;